import $x from '@/utils/$x';

/**
 * 查询调度规则列表
 * @param {*} params
 * @returns
 */
export async function getScheduleList(params) {
  return $x.post('/schedule/admin/list', params);
}

/**
 * 查询调度规则列表
 * @param {*} params
 * @returns
 */
export async function deleteSchedule(params) {
  return $x.post('/schedule/admin/delete', params);
}

/**
 * 查询调度规则列表
 * @param {*} params
 * @returns
 */
export async function getAllScheduleList(params) {
  return $x.post('/schedule/admin/ruleNames', params);
}

/**
 * 获取调度规则对应的渠道活码
 * @param {*} params
 * @returns
 */
export async function getSCRM(params) {
  return $x.post('/schedule/admin/getSCRM', params);
}
/**
 * 根据 bizCode 查询短信模版基本信息
 * @param {*} params
 * @returns
 */
export async function getSmsListByBizCode(params) {
  return $x.post('/littaGoodsSMS/getSmsListByBizCode', params);
}

/**
 * 根据  按场景分页
 * @param {*} params
 * @returns
 */
export async function pageByScene(params) {
  return $x.post('/schedule/admin/pageByScene', params);
}

/**
 * 根据  按日期分页
 * @param {*} params
 * @returns
 */
export async function pageByDateTime(params) {
  return $x.post('/schedule/admin/pageByDateTime', params);
}

/**
 * 根据  按成员分页
 * @param {*} params
 * @returns
 */
export async function pageByEmployee(params) {
  return $x.post('/schedule/admin/pageByEmployee', params);
}

/**
 * 根据  按场景分类-导出excel
 * @param {*} params
 * @returns
 */
export async function excelByScene(params) {
  return $x.post('/schedule/admin/excelByScene', params);
}

/**
 * 根据  按日期分类-导出excel
 * @param {*} params
 * @returns
 */
export async function excelByDateTime(params) {
  return $x.post('/schedule/admin/excelByDateTime', params);
}

/**
 * 根据  按成员分类-导出excel
 * @param {*} params
 * @returns
 */
export async function excelByEmployee(params) {
  return $x.post('/schedule/admin/excelByEmployee', params);
}
